<template>
  <div class="row">
    <div class="col-md-6">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <img :src="product.bild_url" :alt="product.amazonNamenSuche ? `Produktbild: ${product.amazonNamenSuche}` : 'Produktbild'" style="width: auto; height: 130px;">
      </a>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn14 px-1 py-1">Auf Amazon ansehen*</button>
      </a>
    </div>
  </div>
  <div class="product-tabs mt-2">
    <input :id="'tab1-' + productKey" type="radio" :name="'tabs-' + productKey" checked="checked" />
    <input :id="'tab2-' + productKey" type="radio" :name="'tabs-' + productKey" />
    <input :id="'tab3-' + productKey" type="radio" :name="'tabs-' + productKey" />

    <ul class="tabs">
      <li class="tab"> <label :for="'tab1-' + productKey">Allgemein</label> </li>
      <li class="tab"><label :for="'tab2-' + productKey">Funktionen</label> </li>
      <li class="tab"><label :for="'tab3-' + productKey">Komfort & Sicherheit</label> </li>
    </ul>


    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Marke</label>
          <span>{{ textValue('marke') }}</span>
        </div>

        <div class="property">
          <label>Produkttyp</label>
          <span>{{ textValue('produkttyp') }}</span>
        </div>

        <div class="property">
          <label>Bauart / Kammern</label>
          <span>{{ bauartText }}</span>
        </div>

        <div class="property">
          <label>Fassungsvermögen</label>
          <span>{{ capacityText }}</span>
        </div>

        <div class="property">
          <label>Frittierkapazität</label>
          <span>{{ numberValue('friteusenkapazitaet_kg', ' kg', 1) }}</span>
        </div>


        <div class="property">
          <label>Leistung</label>
          <span>{{ numberValue('leistung_w', ' W', 0) }}</span>
        </div>

        <div class="property">
          <label>Temperaturbereich</label>
          <span>{{ temperatureRange }}</span>
        </div>

        <div class="property">
          <label>Maße (B/T/H)</label>
          <span>{{ dimensionsText }}</span>
        </div>


        <div class="property">
          <label>Farbe</label>
          <span>{{ textValue('produktfarbe', 'farbe') }}</span>
        </div>

        <div class="property">
          <label>Material</label>
          <span>{{ textValue('material') }}</span>
        </div>

      </div>

    </div>
    <div class="tab-content">
      <div class="display-properties">
                <div class="property">
                          <div class="property">
          <label>Programme</label>
          <span>{{ numberValue('anzahl_der_programme', '', 0) }}</span>
                          </div>

          <label>Regelbare Temperatur</label>
          <span>{{ booleanValue('regelbare_temperatur') }}</span>
        </div>

          <div class="property">
          <label>Voreingestellte Programme</label>
          <span>{{ booleanValue('voreingestellte_kochprogramme') }}</span>
        </div>

        <div class="property">
          <label>Bratfunktion</label>
          <span>{{ booleanValue('bratfunktion') }}</span>
        </div>

        <div class="property">
          <label>Backfunktion</label>
          <span>{{ booleanValue('backfunktion') }}</span>
        </div>

        <div class="property">
          <label>Grillen</label>
          <span>{{ booleanValue('grillen') }}</span>
        </div>

        <div class="property">
          <label>Röstfunktion</label>
          <span>{{ booleanValue('roestfunktion') }}</span>
        </div>

        <div class="property">
          <label>Digitaler Zeitmesser</label>
          <span>{{ booleanValue('digital_zeitmesser') }}</span>
        </div>

        

      </div>
    </div>
    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Steuerung</label>
          <span>{{ textValue('steuerung') }}</span>
        </div>

        <div class="property">
          <label>Timer</label>
          <span>{{ timerText }}</span>
        </div>

        <div class="property">
          <label>Display</label>
          <span>{{ displayText }}</span>
        </div>

        <div class="property">
          <label>Sichtfenster</label>
          <span>{{ booleanValue('sichtfenster') }}</span>
        </div>

        <div class="property">
          <label>Spülmaschinenfeste Teile</label>
          <span>{{ dishwasherText }}</span>
        </div>

        <div class="property">
          <label>Antihaft-Innenbehälter</label>
          <span>{{ booleanValue('antihaftbeschichteter_innenbehaelter') }}</span>
        </div>

        <div class="property">
          <label>Entfernbare Schüssel</label>
          <span>{{ booleanValue('entfernbare_schuessel') }}</span>
        </div>

        <div class="property">
          <label>Automatische Abschaltung</label>
          <span>{{ autoOffText }}</span>
        </div>

        <div class="property">
          <label>Rutschfeste Füße</label>
          <span>{{ booleanValue('rutschfeste_fuesse') }}</span>
        </div>

        <div class="property">
          <label>Restzeitanzeige</label>
          <span>{{ booleanValue('restzeitanzeige') }}</span>
        </div>

      </div>
    </div>
  </div>


</template>

<script>
import StarRating from "./StarRating.vue";

export default {
  components: {
    StarRating
  },
  props: ['product'],

  computed: {
    productKey() {
      return this.product.id || this.product.icecat_id || this.product.asin || this.product.ean || this.product.ean_icecat || 'airfryer';
    },

    ratingValue() {
      const rating = this.toNumber(this.product.amazonRatingReal || this.product.amazon_rating_real);
      return rating || 0;
    },

    bauartText() {
      const value = this.firstValue(['bauart']);
      if (this.isMissing(value)) return 'Keine Angabe';

      const normalized = String(value).toLowerCase();
      if (normalized.includes('doppel')) return 'Zwei Kammern';
      if (normalized.includes('einzel') || normalized.includes('einzeln')) return 'Eine Kammer';
      if (normalized.includes('ofen')) return 'Airfryer-Ofen';
      if (normalized.includes('schublade')) return 'Schublade';

      return value;
    },

    capacityText() {
      const capacity = this.toNumber(this.firstValue(['fassungsvermoegen_l', 'schuesselkapazitaet_l', 'oel_fuellmenge_l']));
      if (!capacity) return 'Keine Angabe';

      return `${this.formatNumber(capacity, 1)} l`;
    },

    temperatureRange() {
      const min = this.toNumber(this.product.temperatur_min_c);
      const max = this.toNumber(this.product.temperatur_max_c);

      if (min && max) return `${this.formatNumber(min, 0)}–${this.formatNumber(max, 0)} °C`;
      if (max) return `bis ${this.formatNumber(max, 0)} °C`;
      if (min) return `ab ${this.formatNumber(min, 0)} °C`;
      return 'Keine Angabe';
    },

    dimensionsText() {
      const width = this.toNumber(this.firstValue(['breite_mm', 'abmessungen_breite_mm']));
      const depth = this.toNumber(this.firstValue(['tiefe_mm', 'abmessungen_tiefe_mm']));
      const height = this.toNumber(this.firstValue(['hoehe_mm', 'abmessungen_hoehe_mm']));

      if (!width && !depth && !height) return 'Keine Angabe';

      const widthCm = width ? this.formatNumber(width / 10, 1) : 'kA';
      const depthCm = depth ? this.formatNumber(depth / 10, 1) : 'kA';
      const heightCm = height ? this.formatNumber(height / 10, 1) : 'kA';

      return `${widthCm} x ${depthCm} x ${heightCm} cm`;
    },

    displayText() {
      const hasDisplay = this.booleanValue('eingebautes_display');
      const displayType = this.textValue('display_typ');

      if (hasDisplay === 'Ja' && displayType !== 'Keine Angabe') return `Ja, ${displayType}`;
      return hasDisplay;
    },

    dishwasherText() {
      const partsSafe = this.booleanValue('spuelmaschinenfeste_teile');
      const dishwasherSafe = this.booleanValue('spuelmaschinenbestaendig');

      if (partsSafe === 'Ja' || dishwasherSafe === 'Ja') return 'Ja';
      if (partsSafe === 'Nein' && dishwasherSafe === 'Nein') return 'Nein';
      if (partsSafe === 'Nein') return 'Nein';
      if (dishwasherSafe === 'Nein') return 'Nein';

      return 'Keine Angabe';
    },

    autoOffText() {
      const autoOff = this.booleanValue('automatische_abschaltung');
      const afterMinutes = this.toNumber(this.product.automatische_abschaltung_nach_min);

      if (autoOff === 'Ja' && afterMinutes) {
        return `Ja, nach ${this.formatNumber(afterMinutes, 0)} min`;
      }

      return autoOff;
    },

    timerText() {
      const timer = this.booleanValue('digital_zeitmesser');
      const timerMinutes = this.toNumber(this.product.n_99_minuten_timer_min);

      if (timer === 'Ja' && timerMinutes) {
        return `Ja, bis ${this.formatNumber(timerMinutes, 0)} min`;
      }

      if (timerMinutes) {
        return `bis ${this.formatNumber(timerMinutes, 0)} min`;
      }

      return timer;
    },

    cookingAccessoriesText() {
      const accessories = [];
      if (this.product.grillrost == 1) accessories.push('Grillrost');
      if (this.product.grillplatte == 1) accessories.push('Grillplatte');
      if (this.product.backblech == 1) accessories.push('Backblech');
      if (this.product.anzahl_der_spiesse && this.toNumber(this.product.anzahl_der_spiesse) > 0) {
        accessories.push(`${this.formatNumber(this.product.anzahl_der_spiesse, 0)} Spieße`);
      }

      return accessories.length ? accessories.join(', ') : 'Keine Angabe';
    },

    packageText() {
      const packageParts = [];
      if (this.product.rezeptbuch == 1) packageParts.push('Rezeptbuch');
      if (this.product.betriebsanleitung == 1 || this.product.benutzerhandbuch == 1) packageParts.push('Anleitung');
      if (!this.isMissing(this.product.accessories_inklusive)) packageParts.push(this.product.accessories_inklusive);
      if (!this.isMissing(this.product.verpackungsinhalt)) packageParts.push(this.product.verpackungsinhalt);

      return packageParts.length ? packageParts.join(', ') : 'Keine Angabe';
    }
  },

  methods: {
    firstValue(keys) {
      for (const key of keys) {
        const value = this.product[key];
        if (!this.isMissing(value)) return value;
      }

      return null;
    },

    isMissing(value) {
      return value === null || value === undefined || value === '' || value === '-';
    },

    toNumber(value) {
      if (this.isMissing(value)) return null;

      const normalized = String(value)
        .replace(/[^0-9,.-]/g, '')
        .replace(',', '.');

      const number = Number.parseFloat(normalized);
      return Number.isFinite(number) ? number : null;
    },

    formatNumber(value, decimals = 0) {
      const number = this.toNumber(value);
      if (number === null) return null;

      return number.toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    },

    textValue(...keys) {
      const value = this.firstValue(keys);
      return this.isMissing(value) ? 'Keine Angabe' : value;
    },

    numberValue(key, suffix = '', decimals = 0) {
      const number = this.toNumber(this.product[key]);
      if (number === null || number === 0) return 'Keine Angabe';

      return `${this.formatNumber(number, decimals)}${suffix}`;
    },

    booleanValue(key) {
      const value = this.product[key];

      if (value === 1 || value === '1' || value === true || String(value).toLowerCase() === 'ja') {
        return 'Ja';
      }

      if (value === 0 || value === '0' || value === false || String(value).toLowerCase() === 'nein') {
        return 'Nein';
      }

      return 'Keine Angabe';
    }
  },



  mounted() {
  },

};
</script>

<style scoped>
.datasheet-btn {
  background-color: #e6e0d980;
  /* Grün */
  border: none;
  color: rgb(98, 94, 94);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.custom-btn:hover {
  background-color: white;
  color: black;
  border: 2px solid #4CAF50;
}


.datasheet-table th {
  background-color: #e9d9c7;
  color: #0e0808;
  text-align: left;

}

.datasheet-table td,
.datasheet-table th {
  text-align: left;
  font-size: 14px;
}

.datasheet-table label {
  font-weight: bold;
}

.product-tabs {
  overflow-x: hidden;
  border-bottom: 1px solid #ccc;
}

.product-tabs [type="radio"] {
  display: none;
}

.tabs {
  display: flex;
  align-items: stretch;
  list-style: none;
  padding: 0px;
  border-bottom: 1px solid #ccc;
  margin: 0px;
}

.tab>label {
  display: block;
  margin-bottom: -1px;

  border: 1px solid #ccc;
  background: #eee;
  color: #666;
  font-size: 15px;
  font-weight: 600;


  cursor: pointer;
  transition: all 0.3s;
  padding: 2px;
}

.tab:hover label {
  border-top-color: #333;
  color: #333;
}

.tab-content {
  display: none;
  color: #777;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tabs .tab:nth-of-type(1) label,
.product-tabs [type="radio"]:nth-of-type(2):checked~.tabs .tab:nth-of-type(2) label,
.product-tabs [type="radio"]:nth-of-type(3):checked~.tabs .tab:nth-of-type(3) label,
.product-tabs [type="radio"]:nth-of-type(4):checked~.tabs .tab:nth-of-type(4) label {
  border-bottom-color: #fff;
  border-top-color: #B721FF;
  background: #fff;
  color: #222;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tab-content:nth-of-type(1),
.product-tabs [type="radio"]:nth-of-type(2):checked~.tab-content:nth-of-type(2),
.product-tabs [type="radio"]:nth-of-type(3):checked~.tab-content:nth-of-type(3),
.product-tabs [type="radio"]:nth-of-type(4):checked~.tab-content:nth-of-type(4) {
  display: block;
}

.custom-modal-body {
  padding: 0;
}

.display-properties {
  margin: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.property {

  font-size: 15px;
}

label {
  font-weight: bold;
  display: block;
  font-size: 14px;
}

.mt-small-device {
  margin-top: 0;
}

@media (max-width: 576px) {
  .mt-small-device {
    margin-top: 5px;
  }
}

.btn14 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  width: 70%;
  line-height: 1.3;
}
</style>